import React from 'react';
import Menu from './menu';
import heroimg from './images/ritual-hero.png';

class Header extends React.Component {
    render() { 
        return <React.Fragment><header>
        <nav>
          <div className="navlinks">
          <a href="#" id="logo"
                  ><svg
                    width="70"
                    height="25"
                    className="ease-animation-slow"
                    enable-background="new 0 0 352 115.333"
                    version="1.1"
                    viewBox="0 0 352 115.333"
                  >
                    <path
                      fill="#142B6F"
                      d="M83.784,109.63L62.117,77.18c13.142-6.564,20.489-18.159,20.489-32.511	c0-21.472-16.011-37.617-44.441-37.617H5.232V109.63h18.426V82.282h20.054l17.986,27.348H83.784z M40.05,63.422H23.658V25.914H40.05	c13.055,0,23.209,5.842,23.209,18.755C63.26,57.578,53.105,63.422,40.05,63.422 M329.012,7.052h18.422V109.63h-18.422V7.052z M146.311,52.728v34.023c0.293,4.523,2.319,6.639,6.316,6.639c3.992,0,6.968-1.756,9.386-3.688v17.351	c-3.53,2.479-9.519,4.275-16.169,3.881c-4.423-0.264-9.607-2.161-13.243-5.9c-3.146-3.93-4.72-7.829-4.72-14.452V52.728h-9.421	v-16.66h9.421V12.132h18.43v23.936h12.572v16.66H146.311z M237.831,109.615h-16.523l-1.71-8.384	c-3.386,4.416-10.345,9.267-20.496,9.267c-18.24,0-30.638-10.736-30.638-30.301V36.069h18.231v37.983	c0,12.944,5.784,18.535,16.379,18.535c10.589,0,16.523-7.649,16.523-18.535V36.069h18.233V109.615z M319.535,36.158v73.472h-14.747	l-1.712-7.642c-3.085,3.968-11.164,8.522-21.011,8.522c-21.011,0-36.886-15.576-36.886-37.615c0-22.043,15.875-37.62,36.886-37.62	c9.697,0,17.926,4.556,21.011,8.523l1.712-7.641H319.535z M282.628,52.676c-11.188,0-19.813,9.167-19.813,20.22	c0,11.05,8.626,20.215,19.813,20.215c10.918,0,19.275-9.165,19.275-20.215C301.903,61.843,293.546,52.676,282.628,52.676 M91.493,36.066h18.425v73.562H91.493V36.066z M112.609,15.597c0,6.705-5.363,12.14-11.977,12.14	c-6.615,0-11.978-5.435-11.978-12.14c0-6.703,5.362-12.138,11.978-12.138C107.246,3.459,112.609,8.894,112.609,15.597"
                    ></path>
                  </svg>
                </a>
            <div className="unipadding"><div className="nav-w">
              <Menu />
              
              <span className="navleft">
                <a href="#">Who We Are</a>
              
                <a href="#"
                  ><svg
                    className="path"
                    width="24"
                    height="24"
                    version="1.1"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <g>
                        <rect
                          width="24"
                          height="24"
                          x="0"
                          y="0"
                          fill="#FFF"
                          fill-opacity="0"
                        ></rect>
                        <path
                          stroke="#142B6F"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M20.5,6.5 L20.5,23 L4,23 L4,6.5 L20.5,6.5 Z M12.25,1 C14.5281746,1 16.375,2.84682541 16.375,5.125 C16.375,5.43937389 16.3000569,5.88826911 16.1501708,6.47168566 C11.4355784,6.44324758 8.85377775,6.42767434 8.40476894,6.42496595 L8.33387282,6.42453831 C8.33387282,6.42453831 8.125,5.57904881 8.125,5.125 C8.125,2.84682541 9.97182541,1 12.25,1 Z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </a>
              </span></div>
            </div>
          </div>
        </nav>
        <div id="hero-section">
          <div id="hero-img">
            <img src={heroimg} alt="" srcset="" />
            <div id="p-rel">
              <div>
                <p id="hero-title">
   <p>The future</p>  
          <p>of health</p>
     <em> — is clear.</em></p>
              </div>
              <button id="herobtn">Shop All</button>
            </div>
          </div>
        </div>
      </header></React.Fragment>;
    }
}
 
export default Header;